import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { isAllowedOnThisPortal, PORTAL_BRAND } from '../config/institution';

/**
 * Cross-portal SSO landing: receives #p=<base64 payload> from the other security portal login.
 */
export default function SsoPage() {
  const navigate = useNavigate();
  const [error, setError] = useState('');

  useEffect(() => {
    try {
      const hash = window.location.hash.replace(/^#/, '');
      const params = new URLSearchParams(hash.includes('=') ? hash : `p=${hash}`);
      const encoded = params.get('p');
      if (!encoded) {
        setError('Lien SSO invalide.');
        return;
      }
      const raw = decodeURIComponent(escape(atob(encoded)));
      const payload = JSON.parse(raw) as {
        token?: string;
        user?: { role?: string; organization?: string; email?: string };
        ts?: number;
      };
      if (!payload.token || !payload.user) {
        setError('Jeton SSO manquant.');
        return;
      }
      if (payload.ts && Date.now() - payload.ts > 5 * 60 * 1000) {
        setError('Lien SSO expire. Reconnectez-vous.');
        return;
      }
      if (!isAllowedOnThisPortal(payload.user)) {
        setError(`Ce compte n est pas autorise sur le portail ${PORTAL_BRAND.shortName}.`);
        return;
      }
      localStorage.setItem('token', payload.token);
      localStorage.setItem('user', JSON.stringify(payload.user));
      window.location.replace('/');
    } catch (e) {
      console.error(e);
      setError('Impossible de finaliser la connexion SSO.');
    }
  }, [navigate]);

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-indigo-950 text-white p-6">
        <div className="max-w-md text-center space-y-4">
          <h1 className="text-xl font-semibold">{PORTAL_BRAND.fullName}</h1>
          <p className="text-red-300">{error}</p>
          <a href="/login" className="inline-block px-4 py-2 bg-white text-indigo-900 rounded">
            Retour a la connexion
          </a>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-indigo-950 text-white">
      <p>Connexion securisee {PORTAL_BRAND.shortName}…</p>
    </div>
  );
}
